import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, type OnInit } from '@angular/core';
import { UnitService } from '@zaoblako/web/core/services/finance/unit.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { StandardSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/standard-dropdown/standard-single-select/standard-single-select.component';
import type { UnitFindInterface } from '@zaoblako/shared/modules/catalog/dtos/unit/unit-find.dto';

/**
 * @deprecated Use `crm-standard-single-select` and `UnitService.dropdownDescriptorUrl`.
 */
@Component({
  selector: 'crm-unit-single-select',
  standalone: true,
  imports: [SingleSelectComponent, StandardSingleSelectComponent],
  templateUrl: './unit-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitSingleSelectComponent implements OnInit {
  @Input() public units: UnitFindInterface[] = [];
  @Input() public selectedUnit: UnitFindInterface;
  @Output() public selectedUnitChange = new EventEmitter<UnitFindInterface>();
  @Output() public changeValue = new EventEmitter<UnitFindInterface>();
  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = false;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public loading = false;
  public useStandard = false;
  public readonly descriptorUrl: string;

  public constructor(
    unitService: UnitService,
    private readonly globalService: GlobalService
  ) {
    this.descriptorUrl = unitService.dropdownDescriptorUrl;
  }

  public ngOnInit(): void {
    this.useStandard = !this.customRequest && !!this.globalService.globalInfo?.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled;
  }

  public onSelected = (unit: UnitFindInterface): void => {
    this.selectedUnit = unit;
    this.selectedUnitChange.emit(unit);
    this.changeValue.emit(unit);
  };
}
